export const glowLayerStyle = {
  light: {
    opacity: 0.8,
    background:
      'conic-gradient(from 270deg at 50% 50%, #94A5F9 0deg, #5CDBF6 108deg, #FFE175 180deg, #D671F6 288deg, #9F9DF9 360deg)',
    filter: 'blur(7.5px)'
  },
  dark: {
    opacity: 0.8,
    background: `
      conic-gradient(from 135deg at 50% 50%, #E5B400 0deg, #CB3AF3 102.6deg, #03D3FF 232.2deg, #E5B400 360deg)
    `,
    filter: 'blur(7.5px)'
  }
};


export const buttonBoxColorStyle = {
  light: {
    imageSearchButtonStyle: {
      background:
        'radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.88) 0%, rgba(255, 255, 255, 0.00) 100%), conic-gradient(from 270deg at 50% 50%, #94A5F9 0deg, #5CDBF6 108.00000429153442deg, #FFE175 180deg, #D671F6 288.0000042915344deg, #9F9DF9 360deg)',
      boxShadow:
        '-2px -2px 4px 0 rgba(0, 0, 0, 0.06) inset, 1px 2px 4px 0 rgba(255, 255, 255, 0.80) inset, 0 1px 3px 0 rgba(0, 0, 0, 0.07), 0 0 8px 0 rgba(0, 0, 0, 0.03)'
    },
    bgColorStyle: {
      background:
        'linear-gradient(0deg, rgba(255, 255, 255, 0.68) 0%, rgba(255, 255, 255, 0.68) 100%), radial-gradient(50% 50% at 50% 50%, #FFF 0%, rgba(255, 255, 255, 0.00) 100%), conic-gradient(from 135deg at 50% 50%, #FFEFB5 0deg, #EAB0FA 102.59999871253967deg, #90ECFF 232.19999313354492deg, #FFEFB5 360deg)'
    },
    textColorStyle: {
      background: `
    linear-gradient(#5D1E6C30, #5D1E6C30),
    conic-gradient(from 270deg at 50% 50%, #94A5F9 0deg, #5cdbf6 10deg, #5CDBF6 150deg, #FFE175 190deg, #D671F6 340deg, #9F9DF9 360deg)
  `,
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundBlendMode: 'multiply',
      backgroundSize: '120% 100%'
    }
  },
  dark: {
    imageSearchButtonStyle: {
      background:
        'radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.88) 0%, rgba(255, 255, 255, 0.00) 100%), conic-gradient(from 270deg at 50% 50%, #94A5F9 0deg, #5CDBF6 108.00000429153442deg, #FFE175 180deg, #D671F6 288.0000042915344deg, #9F9DF9 360deg)',
      boxShadow:
        '-2px -2px 4px 0 rgba(0, 0, 0, 0.06) inset, 1px 2px 4px 0 rgba(255, 255, 255, 0.80) inset, 0 1px 3px 0 rgba(0, 0, 0, 0.07), 0 0 8px 0 rgba(0, 0, 0, 0.03)'
    },
    bgColorStyle: {
      background: `
    linear-gradient(0deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 100%), 
    radial-gradient(40% 40% at 50% 50%, rgba(255, 255, 255, 0.90) 0%, rgba(255, 255, 255, 0.00) 100%), 
    conic-gradient(from 135deg at 50% 50%, #E5B400 0deg, #CB3AF3 102.6deg, #03D3FF 232.2deg, #E5B400 360deg)
  `
    },
    textColorStyle: {
      background: `
    linear-gradient(#ffffff40, #ffffff40),
    conic-gradient(from 135deg at 50% 50%, #E5B400 0deg, #CB3AF3 75deg, #CB3AF3 100deg, #03D3FF 220deg, #03D3FF 240deg, #E5B400 360deg)
    
  `,
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundSize: '100% 130%'
    }
  }
};
